module.exports = __webpack_public_path__ + "img/67.814eea33.png";